<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="edit-outline"></nb-icon>
        <div class="ml-2" i18n>Creating new DRB version</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body style="min-width: 750px">
    <div style="padding: 1.143em; margin: -1.143em">
      <strong class="text-uppercase" i18n>IMPORTANT:</strong>
      <p i18n>Creating new DRB version sets you as the owner!</p>
      <dl class="row small">
        <dt class="col-2" i18n>Owner:</dt>
        <dd class="col-4">{{ username }}</dd>
      </dl>
    </div>
    <hr />
    <div style="padding: 1.143em; margin: -1.143em">
      <p i18n>Enter the email of the people you want to allow editing of this DRB version</p>
      <form #newDrbForm="ngForm">
        <div *ngFor="let contributor of contributors; let i = index; trackBy: trackByIndex">
          <div class="row">
            <div class="col"><div i18n>Contributor:</div></div>
            <div class="col-9">
              <input
                id="{{ 'contributor' + i }}"
                name="{{ 'contributor' + i }}"
                nbInput
                fullWidth
                placeholder="Contributor {{ i + 1 }}"
                i18n-placeholder
                style="width: 100%"
                [(ngModel)]="contributors[i]"
              />
            </div>
          </div>
          <br />
        </div>
      </form>
      <p class="error">{{ errorMessage }}</p>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <div class="d-flex justify-content-end">
      <button nbButton class="ml-3" status="success" (click)="save()" [disabled]="!newDrbForm.form.valid" i18n>
        Create
      </button>
    </div>
  </nb-card-footer>
</nb-card>
